import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
/***** Rxjs *****/
import { take } from 'rxjs/operators';
/***** Services *****/
import { LanguageService } from './language.service';

export enum ToastrPosition {
  topRight = 'toast-top-right',
  topLeft = 'toast-top-left',
  topCenter = 'toast-top-center',
}

export interface ToastrOptions {
  timeOut?: number,
  progressBar?: boolean,
  positionClass?: ToastrPosition,
  onActivateTick?: boolean,
}

export interface SuccessToastr {
  toastrOptions?: ToastrOptions;
  title?: string;
  subTitle?: string;
  remark?: string;
}
export interface ErrorToastr {
  toastrOptions?: ToastrOptions;
  title?: string;
  subTitle?: string;
  remark?: string;
}

export interface AlertErrorOptions {
  title?: string;
  subTitle?: string;
  err_system?: any; 
  err_custom?: any;
}

@Injectable({
  providedIn: 'root'
})
export class MytoastrService {

  DEFAULT_SUCCESS: SuccessToastr = {
    title: '',
    subTitle: '',
    toastrOptions: {
      timeOut: 2000,
      progressBar: true,
      positionClass: ToastrPosition.topCenter,
      onActivateTick: true,
    }
  };
  DEFAULT_ERROR_OPTIONS: ToastrOptions = {
    timeOut: 2000,
    progressBar: true,
    positionClass: ToastrPosition.topCenter,
    onActivateTick: true,
  };

  constructor(
    private toastr: ToastrService,
    private languageService: LanguageService,
  ) { }

  // 0: 登入
  // 1: 新增
  // 2: 修改
  // 3: 刪除

  // 91: 資料庫連線錯誤
  // 92: Token錯誤
  // 93: 資料庫語法錯誤
  // 94: 搜尋結果-資料已存在
  // 95: 搜尋結果-無資料
  // 96: 無此權限 (web)
  // 99: Request 資料成功
  // 111: 網路錯誤
  // 112: 網路連線逾時
  // 113: API請求錯誤
  // 999: 自定義

  success(code: number, options: SuccessToastr = { 
    title: '',
    subTitle: '',
    toastrOptions: {} 
  }) {
    let title = '';
    let subTitle = '';
    let toastrOption = {
      ...this.DEFAULT_SUCCESS.toastrOptions,
      ...options.toastrOptions
    }
    switch (code) {
      case 0: // 登入成功
        title = options.title ? options.title : '登入成功';
        subTitle = options.subTitle ? options.subTitle : '';
        break;
      case 1: // 新增成功
        title = options.title ? options.title : '新增成功';
        subTitle = options.subTitle ? options.subTitle : '';
        break;
      case 2: // 修改成功
        title = options.title ? options.title : '修改成功';
        subTitle = options.subTitle ? options.subTitle : '';
        break;
      case 3: // 刪除成功
        title = options.title ? options.title : '刪除成功';
        subTitle = options.subTitle ? options.subTitle : '';
        break;
      case 999: // 自定義
        title = options.title ? options.title : '';
        subTitle = options.subTitle ? options.subTitle : '';
        break;
    }
    this.toastr.success(subTitle, title, toastrOption);
  }
  async error(code, alertOptions?: AlertErrorOptions, toastrOptions?: ToastrOptions) {
    let title = '';
    let subTitle = '';

    let _toastrOptions = Object.assign({}, this.DEFAULT_ERROR_OPTIONS);
    if (toastrOptions) _toastrOptions = Object.assign(_toastrOptions, toastrOptions);


    switch (code) {
      case 0: // 登入失敗
        title = alertOptions?.title ? alertOptions.title : '登入失敗';
        subTitle = alertOptions?.subTitle ? alertOptions.subTitle : '帳號或密碼錯誤';
        break;
      case 91: // 資料庫連線錯誤
        title = alertOptions?.title ? alertOptions.title : '資料庫連線錯誤';
        subTitle = alertOptions?.subTitle ? alertOptions.subTitle : '';
        break;
      case 92: // Token 錯誤
        title = alertOptions?.title ? alertOptions.title : '登入認證錯誤或逾期，請重新登入';
        subTitle = alertOptions?.subTitle ? alertOptions.subTitle : '';
        break;
      case 93: // 資料庫語法錯誤
        title = alertOptions?.title ? alertOptions.title : '資料庫語法錯誤，請聯絡工程人員';
        subTitle = alertOptions?.subTitle ? alertOptions.subTitle : '';
        break;
      case 94: // 資料已存在
        let existedColumn = alertOptions.err_system;
        let translatedColumn = await this.languageService.translate
          .get(`table.${existedColumn}`)
          .toPromise<string>()
        title = translatedColumn ? `【${translatedColumn}】已存在，請重新輸入` : '資料已存在';
        subTitle = alertOptions.subTitle ? alertOptions.subTitle : '';
        break;
      case 95: // 無資料
        title = alertOptions?.title ? alertOptions.title : '查無資料';
        subTitle = alertOptions?.subTitle ? alertOptions.subTitle : '';
        break;
      case 96: // 網路錯誤
        title = alertOptions?.title ? alertOptions.title : '網路錯誤，請檢查網路';
        subTitle = alertOptions?.subTitle ? alertOptions.subTitle : '';
        break;
      case 97: // 無權限
        title = alertOptions?.title ? alertOptions.title : '您無此權限';
        subTitle = alertOptions?.subTitle ? alertOptions.subTitle : '';
        break;
      case 111: // 網路錯誤
        title = alertOptions?.title ? alertOptions.title : 'API請求錯誤';
        subTitle = alertOptions?.subTitle ? alertOptions.subTitle : '';
        break;
      case 112: // 網路連線逾時
        title = alertOptions?.title ? alertOptions.title : '網路連線逾時';
        subTitle = alertOptions?.subTitle ? alertOptions.subTitle : '';
        break;
      case 113: // API請求錯誤
        title = alertOptions?.title ? alertOptions.title : '伺服器請求錯誤';
        subTitle = alertOptions?.subTitle ? alertOptions.subTitle : '';
        break;
      case 999: // 自定義
        title = alertOptions?.title ? alertOptions.title : '';
        subTitle = alertOptions?.subTitle ? alertOptions.subTitle : '';
        break;
    }
    this.toastr.error(subTitle, title, _toastrOptions);
  }

  error_invalidForm(options: ErrorToastr = { toastrOptions: {} }): void {
    let title = options.title ? options.title : '儲存失敗';
    let subTitle = options.subTitle ? options.subTitle : '資料填寫錯誤或不完整，請確認。';
    let toastrOption = {
      ...this.DEFAULT_SUCCESS.toastrOptions,
      ...options.toastrOptions
    }
    this.toastr.error(subTitle, title, toastrOption);
  }

  /***** Common *****/
  /* Success */
  success_login() {
    this.languageService.translate
      .get(['登入成功'])
      .pipe(take(1))
      .subscribe(i18n => {
        this.toastr.success('', '登入成功', {
          timeOut: 2000,
          progressBar: true,
          positionClass: ToastrPosition.topCenter,
          onActivateTick: true,
        });
      })
  }
  success_copy(title: string = '複製成功') {
    this.languageService.translate
      .get(['登入成功'])
      .pipe(take(1))
      .subscribe(i18n => {
        this.toastr.success('', title, {
          timeOut: 2000,
          progressBar: true,
          positionClass: ToastrPosition.topCenter,
          onActivateTick: true,
        });
      })
  }

}
